import React, { useState } from 'react';
import LandingPage from './components/LandingPage';
import QAPage from './components/QAPage';
import FinalPage from './components/FinalPage';
import Stars from './components/Stars';
import skillsData from './skills.json';
import './App.css';


const App = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [, setFormData] = useState({}); // State to hold form data
  const category = ["Landing", "General", "Mechanical", "Electrical", "Software", "Final"];
  //generating the evaluation object to use for initial useState(...)
  let evaluation = {};
  Object.entries(skillsData).forEach(([key, value]) => {
    if(key.includes("-title")){
      for (let i = 0; i<value.length; i++){
        evaluation[value[i]] = 0;
      }
    }
    evaluation["Desired Level"] = "";
    evaluation["Name"] = "";
    evaluation["Surname"] = "";
    evaluation["Email"] = "";
    evaluation["Qualification"] = "";
    evaluation["Age"] = "";
    evaluation["Gender"] = "";
    evaluation["Personality Type"] = ""; //https://www.16personalities.com/ (10 minutes)
    evaluation["Additional Comments"] = "";
    evaluation["Expected Remuneration"] = "";
    evaluation["submit"] = false;
    evaluation["submit attempt"] = false;
  });
  //setting up evaluationData state
  const [evaluationData, setEvaluationData] = useState(evaluation); // State to hold form data
  const handleInputChange = (name, value) => {
    //changing the evaluationData when a radio button changes - using state object so that all components have access to the change (React nuance)
    setEvaluationData((prevData) => ({
      ...prevData,
        [name]: value,
    }));
    
    if(!(!evaluationData['submit'] && !evaluationData['submit'])){
      setEvaluationData((prevData) => ({
        ...prevData,
          submit: false,
          "submit attempt": false,
      }));
    }
  };

  const handleNext = (data) => {
    setFormData((prevData) => ({
      ...prevData,
      [category[currentPage]]: data,
    }));
    setCurrentPage(currentPage + 1);
  };

  const handlePrev = () => {
    setCurrentPage(currentPage - 1);
  };
  
  const handleSubmit = () => {
    // Process and submit form data to the handler URL
    const handlerUrl = 'https://application.digitorumflex.com/handle-user-evaluation-data.php?password=ryanmilo';
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(evaluationData),
    };

    fetch(handlerUrl, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        // Handle the response from the server
        if(!(evaluationData['submit'] && evaluationData['submit'])){
          setEvaluationData((prevData) => ({
            ...prevData,
              submit: true,
              "submit attempt": true,
          }));
        }
      })
      .catch((error) => {
        console.error('Error submitting form data:', error);
        if(!(!evaluationData['submit'] && evaluationData['submit'])){
          setEvaluationData((prevData) => ({
            ...prevData,
              submit: false,
              "submit attempt": true,
          }));
        }
      });
  };

  if (!skillsData) {
    return <div>Loading...</div>;
  }
  return (
    <div className="App">
      <Stars/>
      {currentPage === 0 && <LandingPage onNext={handleNext} evaluation={evaluationData} inputChange={handleInputChange} />}
      {currentPage === 1 && (
        <QAPage
          skills={skillsData}
          evaluation={evaluationData}
          onNext={handleNext}
          onPrev={handlePrev}
          category={category[currentPage]}
          page={currentPage}
          inputChange={handleInputChange}
          onSubmit={handleNext} // Pass onSubmit to trigger handleNext in QAPage
        />
      )}
      {currentPage === 2 && (
        <QAPage
          skills={skillsData}
          evaluation={evaluationData}
          onNext={handleNext}
          onPrev={handlePrev}
          category={category[currentPage]}
          page={currentPage}
          inputChange={handleInputChange}
          onSubmit={handleNext} // Pass onSubmit to trigger handleNext in QAPage
        />
      )}
      {currentPage === 3 && (
        <QAPage
          skills={skillsData}
          evaluation={evaluationData}
          onNext={handleNext}
          onPrev={handlePrev}
          category={category[currentPage]}
          page={currentPage}
          inputChange={handleInputChange}
          onSubmit={handleNext} // Pass onSubmit to trigger handleNext in QAPage
        />
      )}
      {currentPage === 4 && (
        <QAPage
          skills={skillsData}
          evaluation={evaluationData}
          onNext={handleNext}
          onPrev={handlePrev}
          category={category[currentPage]}
          page={currentPage}
          inputChange={handleInputChange}
          onSubmit={handleNext} // Pass onSubmit to trigger handleNext in QAPage
        />
      )}
      {currentPage === 5 && (
        <FinalPage onSubmit={handleSubmit} onPrev={handlePrev} evaluation={evaluationData} inputChange={handleInputChange} />
      )}
    </div>
  );
};

export default App;
